<template>
	<main style="background-color: #1D1D1B;">
		<!-- <NavigationCard image="/assets/img/Products/navigation.png" title="PRODUCT CATEGORY" /> -->

		<NavigationCard topUrl="../../../assets/img/TopFirst/ProductTop.mp4" topUrlType="video" />
		<section>
			<div class="align-content-center m-4">
				<div class="page_title" style="display: flex;justify-content: center;">
					<div class="page_title" style="display: flex;justify-content: center;">
						<div>
							<h3 class="page_title" style="display: inline-block;
							height: 4.1rem;
							border-bottom: 3px solid rgb(252, 180, 46); color: rgb(252, 180, 46);">Products </h3>
						</div>
					</div>
				</div>
			</div>
			<div style="display: flex; width: 100%;justify-content:right;padding-right: 212px;">
				<SearchInput v-model="inputValue" style="width: 310px;" @keyEnter="searchData" />
			</div>
		</section>

		<div style="width: 100%;background-color: #2C2C2B;">
			<table style="background-color: #2C2C2B;margin: 0 auto;">
				<tr>
					<td style="vertical-align: top; padding: 0;background-color: #1D1D1B;min-width: 240px;">
						<div class="tree-box" style="width: 100%;">
							<div style=" height: 30px;background-color: #2C2C2B;text-align: left;; line-height: 30px;">
								<div class="custom-header" style=" display: flex;text-align: center;">

								</div>
							</div>
							<div class="tree-content" style="padding-top: 10px;">
								<el-tree ref="treeleft" :data="filteredTreeData" node-key="id" :indent="0"
									class="tree-line"
									:row-style="{'padding-top':'00px','padding-bottom':'0px',height:'30px','line-height':'30px'}"
									@cell-style="{color:red}" :default-expand-all="isLeftExp" :highlight-current="false"
									:expand-on-click-node="false" @node-click="handleNodeClick">
									<span slot-scope="{ node,data }" class="custom-tree-node">
										<template>
											<div class="node_div">
												<span class="name-box"
													:style="{ color: node.childNodes && node.childNodes.length > 0 ? (node.isCurrent ?'black':'orange') : 'white' }">
													{{ data.name }}
													<span v-if="data.itemNum">({{data.itemNum}})</span>
												</span>
											</div>
										</template>
									</span>
								</el-tree>
							</div>
						</div>
					</td>
					<td class="container col-md-10-1" style="vertical-align: top;padding: 0;width: calc(100%-240px);">

						<!-- <div class="width_10" style="background-color: #434343;padding: 6px 80px ;height: 40px;display: flex; text-align: right;width: 100%;justify-content:right;">
							<SearchInput class="" v-model="inputValue" style="margin-right: 50px;"/>
						</div> -->
						<section>
							<div class="row" style="margin-left: 170px;margin-right: 120px;margin-top: 30px;">
								<div class=" mb-4"
									style="padding-left: 5px;padding-right: 5px;display: flex;width: 320px;position: relative;"
									v-for="product in paginatedData" :key="product.id" @mousedown="handleMouseDown"
									@mouseup="handleMouseUp(product)">
									<div class="card shadow-sm card-border" style="position:relative;">
										<div style="text-align: center;">
											<img class="card-img-top" :src="product.coverUrl" alt="Card image cap"
												style="width: 320px;">
										</div>
										<div class="card-body card-body-list" style="padding-top: 0;">
											<p class="card-title"
												style="color: #FCB42E; font-size: 24px;font-weight: bold;">
												{{product.code}}</p>
											<p class="card-title " style="font-size: 14px;">
												{{ product.name }}
											</p>
											<p class="card-text"
												style="font-size: 12px;line-height: 1.2;color: #707070 ;font-family: regular;"
												v-html="product.remark">
												<!-- {{ product.remark }} -->
											</p>


										</div>
									</div>
									<div v-if="product.isNew==1"
										style="position: absolute;margin-left: 8px; max-height: 15px;right: 10px;top: 5px;">
										<img src="../../../public/assets/img/newlogo.png" alt="">
									</div>
								</div>
							</div>
							<!-- <div>
								<div :v-for="product in products" :key="product.id">
									<img :src="product.image" :alt="product.name" >
									<div>
										<h3 class="text-orange-500 font-semibold mb-2">{{ product.model }}</h3>
										<h4 class="text-white font-medium mb-2">{{ product.name }}</h4>
										<p class="text-gray-400 text-sm">{{ product.description }}</p>
									</div>
									
								</div>
								
							</div> -->

							<!-- <el-pagination
								@current-change="handleCurrentChange"
								:current-page="currentPage"
								:page-sizes="[10, 20, 30, 40]"
								:page-size="pageSize"
								layout="total, sizes, prev, pager, next, jumper"
								:total="totalData">
							</el-pagination> -->
							<el-pagination background layout="prev, pager, next" :hide-on-single-page="value"
								:total="totalData" :page-size="pageSize" @current-change="handleCurrentChange"
								:current-page="currentPage">
							</el-pagination>
						</section>


					</td>
				</tr>

				<tr style="height: 50px;">
					<td style="background-color: #1D1D1B"></td>
					<td></td>
				</tr>
			</table>
		</div>




		<!-- <el-table :data="treeData" style="width: 100%" row-key="id"  highlight-current-row
						:tree-props="{ children: 'children' }"
						default-expand-all :header-cell-style="{padding:0,height:'40px',backgroundColor:'#434343',border:0,color:'white','text-align':'center'}" 
						:cell-style="{padding:'0px 0px 0px 0px',border:0,backgroundColor:'#2C2C2B','font-size':'15px',color:'#BBBBBB '}"
						ref="tableLeft" show-expand>
							<el-table-column prop="name" label="Expand all" width="cale(100%-200)">
								<template #header="{ column }">
										<div class="custom-header" style=" display: flex;text-align: center;">
											<div style="position: relative;text-align: center;width: 100%;">
												{{ column.label }}
											</div>
											<div style="position: absolute;">
												<img src="/assets/img/Products/展开折叠.png" class="header-image" style=" margin-left: 8px; height: 20px;" @click="Expandcollapse"/>
											</div>
										
										</div>
								</template>
							</el-table-column>
						
						</el-table> -->

	</main>

</template>

<script>
	// import NavigationCard from '@/components/common/NavigationCard.vue';
	import NavigationCard from '@/components/common/TopVideo.vue';
	import SearchInput from '@/components/common/SearchInput.vue';
	import { getProductMain, getProductTypeNum } from "@/api/rbac/product";
	// import {setDefaultNode} from "@/api/rbac/tree";
	export default {
		name: 'Products',
		components: {
			NavigationCard,
			SearchInput
		},
		data() {
			return {
				inputValue: '',
				treeData: [],
				productData: [],
				// 当前页码
				currentPage: 1,
				// 每页显示的数据条数
				pageSize: 8,
				// 总数据条数
				totalData: 0,
				isLeftExp: true,
				value: true,
				isClicking: false,
				treeDataTemp: [],
				originProducts: [],
			};
		},
		methods: {
			navigateTo() {
				this.$router.push(`${this.$route.path}/name`);
			},
			Expandcollapse() {
				// const treeNodes=this.$refs.treeleft.store.nodesMap;
				this.isLeftExp = !this.isLeftExp;
				// this.$refs.treeleft.store.root.expanded=this.isLeftExp;
				const nodes = this.$refs.treeleft.store._getAllNodes();

				for (let key in nodes) {
					nodes[key].expanded = this.isLeftExp;
				}
				// 
			},
			// 当前页码改变时的处理函数
			handleCurrentChange(page) {
				this.currentPage = page;
			},
			//获取类型数据
			getTypeList() {
				console.log(this.user)
				var strWhere = ''
				if (this.user == null) {
					if (!this.$isDevelopment) {
						strWhere = ' and DATEDIFF(mm,happendate,getDate())>=(select MAX(intMonth) from WebUserLevelSet)'
					}
				}
				else {
					if (this.user.isCus == 1) {
						strWhere = ` and DATEDIFF(mm,happenDate,GETDATE())>=${this.user.intMonth}`
					}
				}
				getProductTypeNum({ isProduct: 1, strWhere: strWhere }).then(res => {
					if (res.data.length == 0) {
						// console.log(this.treeData)
						this.productData = []
					}
					else {
						this.treeData = res.data;
					}

					if (this.$route.params.category != undefined) {
						var node = this.treeData[0].children.filter(item => item.name == this.$route.params.category)
						if (node.length > 0) {
							this.$nextTick(() => {
								this.$refs.treeleft.setCurrentKey(node[0].id);
							});
							strWhere += ' and b.pID=' + node[0].realID
							this.loadDataList(strWhere, ' ');
						}
						else {
							this.productData = [];
						}
					}
					else {
						if (this.treeData.length > 0) {
							this.$nextTick(() => {
								this.$refs.treeleft.setCurrentKey(this.treeData[0].id);
							});

							this.loadDataList(strWhere, ' isnull(a.mainSort,99999),');
						}
					}

				})

			},
			handleNodeClick(data, node, tree) {
				this.inputValue = ''
				console.log('Node11 clicked:', data, node, tree);
				var strWhere = ''
				if (this.user == null) {
					if (!this.$isDevelopment) {
						strWhere = ' and DATEDIFF(mm,happendate,getDate())>=(select MAX(intMonth) from WebUserLevelSet)'
					}
				}
				else {
					if (this.user.isCus == 1) {
						strWhere = ` and DATEDIFF(mm,happenDate,GETDATE())>=${this.user.intMonth}`
					}
				}
				var sort = ''
				if (node.data.pID == 0) {
					// this.loadDataList('');
					strWhere += ''
					sort = ' isnull(a.mainSort,99999),'
				}
				else {
					if (node.childNodes.length > 0) {
						// this.loadDataList(' and b.pID=' + node.data.realID);
						strWhere += ' and b.pID=' + node.data.realID
					}
					else {
						// this.loadDataList(' and b.ID=' + node.data.realID);
						strWhere += ' and b.ID=' + node.data.realID
					}
				}
				this.loadDataList(strWhere, sort);
				// 在这里处理节点点击的逻辑
			},
			searchData(value) {
				if (this.originProducts.length == 0) {
					this.originProducts = this.productData
				}
				if (value.length == 0) {
					this.productData = this.originProducts
					this.originProducts = []
				}
				else {
					this.productData = this.originProducts.filter(product => product.code.toLowerCase().includes(value.toLowerCase()));
				}
				this.currentPage = 1;
				this.totalData = this.productData.length
			},
			//获取产品数据
			async loadDataList(strWhere, sort) {
				this.inputValue='';
				this.originProducts=[];
				this.currentPage = 1;
				strWhere = ' and a.isProduct=1 ' + strWhere
				try {
					getProductMain({ strWhere: strWhere, sort: sort }).then(res => {

						this.totalData = res.data.length;
						if (res.data.length == 0) {
							// console.log(this.dataList)
							this.productData = [];
						}
						else {
							this.productData = res.data;
							this.productData.forEach(element => {
								if (element.coverUrl != null) {
									element.coverUrl = '../../../assets/img/ProductCover/' + element.coverUrl
								}
								if (element.mainUrl != null) {
									element.mainUrl = '../../../assets/img/ProductHome/' + element.mainUrl
								}
								if (element.hoverUrl != null) {
									element.hoverUrl = '../../../assets/img/ProductHome/' + element.hoverUrl
								}
							});
						}
					})


				} catch (error) {
					console.error('获取失败:', error);
				}
			},
			//判断点击还是选择文本
			handleMouseDown() {
				this.isClicking = true; // 标记开始点击过程
				this.message = ''; // 重置消息
			},
			handleMouseUp(product) {
				if (this.isClicking) {
					this.isClicking = false; // 标记点击过程结束
					// console.log(product)
					// 检查是否有文本选择
					if (!this.isTextSelected()) {
						// this.$router.push(`${this.$route.path}/name`);
						this.$router.push({ name: 'product', params: { category: product.id, productsName: product.mainCodeID } })
					}
				}
			},
			isTextSelected() {
				const selection = window.getSelection();
				return selection.toString().length > 0;
			},
			// handleCurrentChange(val) {
			// 	this.currentPage = val;
			// },
			filterTree(node) {
				if (!node.children || node.children.length === 0) {
					return node.itemNum > 0 ? [node] : [];
				}

				const filteredChildren = node.children.map(child => this.filterTree(child)).flat();

				if (node.itemNum > 0 || filteredChildren.length > 0) {
					return [{ ...node, children: filteredChildren }];
				}

				return [];
			},
		},
		created() {
			this.getTypeList();

		},
		mounted() {
			// 确保数据加载完成后设置默认选中节点

		},
		computed: {
			// totalPages() {
			// 	console.log('pagecount',Math.ceil(this.productData.length / this.pageSize))
			// 	return Math.ceil(this.productData.length / this.pageSize);
			// },
			// 计算属性，用于获取当前页的数据
			paginatedData() {
				const start = (this.currentPage - 1) * this.pageSize;
				const end = this.currentPage * this.pageSize;
				return this.productData.slice(start, end);
			},
			user() {
				if (this.$store.state.user == null) {
					var storUser = localStorage.getItem("token")
					if (storUser == null) {
						return this.$store.state.user
					}
					else {
						var thisuser = JSON.parse(storUser);
						return thisuser
					}

				}
				else {
					return this.$store.state.user
				}
				// 使用计算属性来获取用户信息，这样当用户信息变化时，界面也会自动更新
			},
			filteredTreeData() {
				return this.treeData.map(node => this.filterTree(node)).flat();
			}
		},

	};
</script>

<style scoped lang="scss">
	@import '../../assets/css/main.css';

	.tree-line {
		background-color: transparent;
		color: #D3D3D2;
	}

	::v-deep .el-tree-node.is-current>.el-tree-node__content {
		background: #FCB42E !important;
		color: black;
	}

	:deep(.el-pager li) {
		background-color: #434343 !important;
	}

	:deep(.btn-next) {
		background-color: #434343 !important;
	}

	:deep(.btn-prev) {
		background-color: #434343 !important;
	}

	:deep(.photo-group) {
		display: flex;
		justify-content: center;
		flex-wrap: wrap;
		background: linear-gradient(to bottom, #0E0C06, #2B2B2B);
	}

	:deep(.photo-container) {
		text-align: center;
		position: relative;
		width: 12rem;
		height: 8.5rem;
		cursor: pointer;
		display: flex;
		justify-content: center;
	}

	@media (max-width: 576px) {
		:deep(.photo-container) {
			width: 10rem;
		}
	}

	:deep(.photo-container img) {
		position: absolute;
		width: 100%;
		height: 100%;
		object-fit: contain;
		transition: opacity 1s ease;
	}

	:deep(.photo-container img.default-img) {
		opacity: 1;
	}

	:deep(.photo-container img.hover-img) {
		opacity: 0;
	}

	/* 鼠标悬浮时切换图片 */
	:deep(.photo-container:hover img.default-img) {
		opacity: 0;
	}

	:deep(.photo-container:hover img.hover-img) {
		opacity: 1;
	}

	:deep(.photo-group h3) {
		height: 2rem;
		margin: 0 0 10px;
		font-family: 'dengxian', serif;
		font-size: 18px;
		border-bottom: 1px solid #2C2C2B;
		text-align: left;
		padding-left: 25%;
		transition: color 1s ease;
	}

	:deep(.photo-container:hover + h3) {
		color: #FCB42E;
	}

	ul:deep(.photo-title.active) {
		color: #FCB42E;
	}

	:deep(.photo-group ul) {
		list-style: none;
		padding: 0;
		margin: 0;
	}

	:deep(.photo-group ul li) {
		color: #fff;
		margin-bottom: 5px;
		font-size: 14px;
		text-align: left;
		padding-left: 25%;
	}

	:deep(.card) {
		background-color: #000000;
	}

	:deep(.card-title) {
		font-weight: 600;
		margin-bottom: 0rem;
	}

	:deep(.card-sub-title) {
		color: #fff;
		height: 1.5rem;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	:deep(.card-border) {
		border: 1px solid #474746;
	}

	:deep(.card-img-top) {
		/* min-height: 14.5rem;
		max-height: 14.5rem; */
		width: 320px;
		height: 276px;
		background: linear-gradient(to bottom right, #2C2C2C, #000000);
	}

	:deep(.card-body-list) {
		text-align: left;
		height: 12.3rem;
		background-color: #000000;
		border-bottom-left-radius: calc(0.25rem - 1px);
		border-bottom-right-radius: calc(0.25rem - 1px);
	}

	:deep(.multiline) {
		color: #5F5F5F !important;
		overflow: hidden;
		font-size: 15px;
		display: -webkit-box;
		-webkit-line-clamp: 4;
		-webkit-box-orient: vertical;
		text-overflow: ellipsis;
	}

	/* :deep(.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li){
		color: white;
	}
	.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
		color: red;
	} */
	:deep(.el-pagination.is-background .el-pager li:not(.disabled):not(.active)) {
		color: white !important;
	}

	:deep(.el-pagination.is-background .el-pager li:not(.disabled).active) {
		color: white;
		background-color: orange !important;
	}

	.levelClass {
		color: red;
	}

	.nodeClickClass {
		background-color: #FCB42E;
		color: black;
	}
</style>